export default class TrackingService {

    constructor() {
        /*                                    */
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                }
            }
        }

        /*                                    */
        this.util = window.o_util || {};
        if (!this.util.o_util) {
            this.util.o_util = {
                misc: {
                    getPagecluster: () => {}
                }
            }
        }
    }

    sendLoadedTrackingEvent(featureOrder, featureIndex, promoType, promoContent) {
        const trackingData = [
            this._createContentLabel(featureOrder, featureIndex, promoType, "loaded"),
            this._createContentTileLabel(featureIndex, promoType, promoContent, "loaded")
        ];
        this.global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingData);
    }

    sendClickTrackingEvent(featureOrder, featureIndex, promoType, promoContent) {
        let trackingData = {
            name: "click",
            features: [
                this._createContentLabel(featureOrder, featureIndex, promoType, "clicked"),
                this._createContentTileLabel(featureIndex, promoType, promoContent, "clicked")]
        }
        let pageCluster = window.o_util.misc.getPagecluster();
        const labels = {
            "wk.promo_AttributionFeature": promoType + "_" + pageCluster,
            "wk.promo_AttributionSource": "manual"
        }
        this.global.eventQBus.emit('tracking.bct.submitMoveAction', labels, trackingData);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": promoType});
    }

    sendScrollTrackingEvent(promoType, featureIndex) {
        let parentFeature = {'featureId': this._getParentFeatureId(promoType, featureIndex)}
        let tileFeature = {'featureId': this._getTileFeatureId(promoType, featureIndex)}
        this.global.eventQBus.emit('tracking.bct.submitMiniActions', [parentFeature, tileFeature]);
    }

    _createContentLabel(featureOrder, featureIndex, promoType, status) {
        return {
            id: this._getParentFeatureId(promoType, featureIndex),
            name: promoType,
            position: featureOrder,
            status: status,
            labels: {
                promo_Feature: ["true"],
                promo_FeatureNumber: [(featureIndex + 1).toString()]
            }
        }
    }

    _createContentTileLabel(featureIndex, promoType, promoContent, status) {
        return {
            id: this._getTileFeatureId(promoType, featureIndex),
            parentId: this._getParentFeatureId(promoType, featureIndex),
            name: promoType + "-" + this._getPromoTypeChildName(promoType),
            position: 1,
            status: status,
            labels: this._createContentTileLabelLabels(promoType, promoContent)
        };
    }

    _createContentTileLabelLabels(promoType, promoContent) {
        let labels = {
            promo_Source: ["manual"],
            promo_Content: [promoContent]
        }
        switch (promoType) {
            case 'Video': {
                labels.ot_VideoRequestKey = [promoContent];
                labels.ot_Video = ["view"];
                break;
            }
            case 'Textlink': {
                if (promoContent.indexOf("selektion=") >= 0) {
                    labels.promo_TargetPsr = [promoContent.split("selektion=")[1].split("&")[0]];
                }
            }
        }
        return labels;
    }

    _getPromoTypeChildName(promoType) {
        switch (promoType) {
            case 'Textlink': {
                return "Link";
            }
            case 'Video': {
                return "Video";
            }
            default: {
                return 'unknown'
            }
        }
    }

    _getParentFeatureId(promoType, featureIndex) {
        return 'ft3_' + this._getIdByPromoType(promoType) + featureIndex;
    }

    _getTileFeatureId(promoType, featureIndex) {
        return this._getParentFeatureId(promoType, featureIndex) + '_tile';
    }

    _getIdByPromoType(promoType) {
        switch(promoType) {
            case 'Textlink': {
                return "tl";
            }
            case 'Video': {
                return "vi";
            }
            default: {
                return 'unknown'
            }
        }
    }
}
